const DEFAULT_FLEET_SIGNUP_ORIGIN = 'https://ops.goodjourney.io';

export function getFleetSignupOrigin() {
  return (
    process.env.REACT_APP_FLEET_SIGNUP_ORIGIN || DEFAULT_FLEET_SIGNUP_ORIGIN
  ).replace(/\/$/, '');
}

export function buildFleetSignupUrl(pathname = '/signup', search = '') {
  const path = pathname.startsWith('/signup') ? pathname : '/signup';
  return `${getFleetSignupOrigin()}${path}${search || ''}`;
}

export function redirectToFleetSignup(pathname = '/signup', search = '') {
  const targetUrl = buildFleetSignupUrl(pathname, search);
  if (window.location.href === targetUrl) {
    return;
  }
  window.location.replace(targetUrl);
}

export function shouldRedirectFleetSignupFromCurrentHost() {
  try {
    return window.location.origin !== new URL(getFleetSignupOrigin()).origin;
  } catch {
    return true;
  }
}
